import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';
import { handleFormErrors } from '../form/utils';


export default class BetaCreate extends Component {
  constructor(props) {
    super(props);
    this.checkUser = this.checkUser.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.addUser = this.addUser.bind(this);

    this.state = {
      email: '',
      query: {},
      result: '',
      added: '',
      totalUsers: '',
    };
  }

  componentDidMount() {
    BlitzAPI.getTotalBetaUsers().then(resp => this.setState({ totalUsers: resp.data.count }));
  }

  onEmailChange(e) {
    this.setState({ email: e.target.value });
    let { query } = this.state;
    if (!e.target.value) {
      delete query.email;
    } else {
      query = Object.assign({}, query, { email: e.target.value });
    }
    this.setState({ query }, this.getData);
  }

  checkUser() {
    BlitzAPI.postCheckActivated({ email: this.state.email }).then((resp) => {
      this.setState({ result: resp.data });
    });
  }

  addUser() {
    const { email } = this.state;
    return BlitzAPI.postAddBetaUser({ email }).then(
      resp => this.setState({ added: resp.data }),
    );
  }

  render() {
    const { email, result, added, totalUsers } = this.state;

    return (
      <div>
        <h1>Search for a user</h1>
        <div>Total beta users: {totalUsers}</div>
        <div>
          <label htmlFor="userSearch">Search</label>
          <input value={email} onChange={this.onEmailChange} />
          <Button onClick={this.checkUser}>Check Email</Button>
        </div>
        {result && <div>{JSON.stringify(result)}</div>}
        <br />
        <Button onClick={this.addUser}>Add Email</Button>
        {added && <div>{added.success}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/beta/BetaCreate.js